import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import { commandWorkspaceCohortCollaboratorsSummary } from '../actions';
import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { accountOrTeamId, collaboratorType, cohortId } = action;

  const workspaceCohortPermissionRevoke = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_COHORT_PERMISSION_REVOKE,
    [`${collaboratorType}Id`]: accountOrTeamId,
    cohortId,
  });

  if (workspaceCohortPermissionRevoke.type === constants.RTM_WORKSPACE_COHORT_PERMISSION_REVOKE_OK) {
    yield put(commandWorkspaceCohortCollaboratorsSummary(cohortId));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: workspaceCohortPermissionRevoke.message || <FormattedMessage {...messages.permissionRevokeError} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_REVOKE_PERMISSION_ON_COHORT, catchErrors, sendRequest, connection);
}
